import { organizationFlags, organizationFlagsEnum, tileTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { enumLabel } from "helpers/system";
import { numberInRange, positiveInteger, requiredField } from "helpers/validators";

const defaultDaysBeforeBlockForNotification = 3;

const config = {
    bidRecalculationOffsetHours: {
        label: "Период анализа посещения точек",
        inputProps: {
            name: "bidRecalculationOffsetHours",
            type: "number",
            step: "1",
            placeholder: "От 48 до 96",
            min: 48,
            max: 96,
        },
        fieldWrapper: "col-9",
        required: true,
        validators: [requiredField, (value) => numberInRange(value, 48, 96)],
    },
    maxFileSizeInMb: {
        label: "Макс. размер файла (МБ)",
        inputProps: {
            name: "maxFileSizeInMb",
            type: "number",
            step: "1",
            placeholder: "От 10 до 1024",
            min: 10,
            max: 1024,
        },
        fieldWrapper: "col-9",
        validators: [(value) => value != null && numberInRange(value, 10, 1024)],
    },
    code: {},
    relayIds: {},
    relay: {
        configurationId: {
            label: "ID конфигурации",
            inputProps: { name: "configurationId" },
        },
        relayId: {
            label: "ID релея",
            inputProps: { name: "relayId" },
        },
        relayApiKey: {
            label: "API ключ ретранслятора",
            inputProps: { name: "relayApiKey" },
        },
        retType: {
            label: "Тип ретранслятора",
            inputProps: { name: "retType" },
        },
        retId: {
            label: "ID типа релея на стороне ретранслятора",
            inputProps: { name: "retId" },
        },
        connectionProposal: {
            dontShowAlert: {
                label: "Не показывать баннер подключения мониторинга",
                type: "checkbox",
                inputProps: { name: "dontShowAlert" },
                fieldBeforeLabel: true,
                labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
                fieldWrapper: "col-auto offset-sm-4 offset-md-3 d-flex align-items-center",
            },
        },
    },
    canCreateBids: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.CanCreateBids),
        type: "checkbox",
        inputProps: { name: "canCreateBids" },
    },
    autoSetMainContract: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.AutoSetMainContract),
        type: "checkbox",
        inputProps: { name: "autoSetMainContract" },
    },
    displayLateAndIdleTimeInReport: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.DisplayLateAndIdleTimeInReport),
        type: "checkbox",
        inputProps: { name: "displayLateAndIdleTimeInReport" },
    },
    allowUnloadPointAdjustmentUsage: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.AllowUnloadPointAdjustmentUsage),
        type: "checkbox",
        inputProps: { name: "allowUnloadPointAdjustmentUsage" },
    },
    noAccessToEditBooks: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.NoAccessToEditBooks),
        type: "checkbox",
        inputProps: { name: "noAccessToEditBooks" },
    },
    hasCompoundCargos: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.HasCompoundCargos),
        type: "checkbox",
        inputProps: { name: "hasCompoundCargos" },
    },
    usesDriverManualBidCompletion: {
        label: "Отображать завершенную заявку водителю",
        type: "checkbox",
        inputProps: { name: "usesDriverManualBidCompletion" },
    },
    analyzeOverallReportByHourlyMileage: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.AnalyzeOverallReportByHourlyMileage),
        type: "checkbox",
        inputProps: { name: "analyzeOverallReportByHourlyMileage" },
    },
    limitedFunctionality: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.LimitedFunctionality),
        type: "checkbox",
        inputProps: { name: "limitedFunctionality" },
    },
    suitableOrders: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.SuitableOrders),
        type: "checkbox",
        inputProps: { name: "suitableOrders" },
    },
    prohibitionOfRevertingBidForHeadLogist: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.ProhibitionOfRevertingBidForHeadLogist),
        type: "checkbox",
        inputProps: { name: "prohibitionOfRevertingBidForHeadLogist" },
    },
    adminHasAccessToDriverPasswords: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.AdminHasAccessToDriverPasswords),
        type: "checkbox",
        inputProps: { name: "adminHasAccessToDriverPasswords" },
    },
    useCargorunRouterOnly: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.UseCargorunRouterOnly),
        type: "checkbox",
        inputProps: { name: "useCargorunRouterOnly" },
    },
    adminCanDownloadDriverList: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.AdminCanDownloadDriverList),
        type: "checkbox",
        inputProps: { name: "adminCanDownloadDriverList" },
    },
    isDocumentReceivingMandatory: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.IsDocumentReceivingMandatory),
        type: "checkbox",
        inputProps: { name: "isDocumentReceivingMandatory" },
    },
    parallelItemChangePoints: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.ParallelItemChangePoints),
        type: "checkbox",
        inputProps: { name: "parallelItemChangePoints" },
    },
    trackEmptyMileageBidTypes: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.TrackEmptyMileageBidTypes),
        type: "checkbox",
        inputProps: { name: "trackEmptyMileageBidTypes" },
    },
    updateStartedByWhenCarChanged: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.UpdateStartedByWhenCarChanged),
        type: "checkbox",
        inputProps: { name: "updateStartedByWhenCarChanged" },
    },
    useOdometerMileage: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.UseOdometerMileage),
        type: "checkbox",
        inputProps: { name: "useOdometerMileage" },
    },
    useTrailerMileage: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.UseTrailerMileage),
        type: "checkbox",
        inputProps: { name: "useTrailerMileage" },
    },
    allowEditingCompletedBidsForEnterprise: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.AllowEditingCompletedBidsForEnterprise),
        type: "checkbox",
        inputProps: { name: "allowEditingCompletedBidsForEnterprise" },
    },
    forceCompleteOnLastPointManualDates: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.ForceCompleteOnLastPointManualDates),
        type: "checkbox",
        inputProps: { name: "forceCompleteOnLastPointManualDates" },
    },
    hasAccessToEditCars: {
        label: "Доступ к редактированию машин",
        type: "checkbox",
        inputProps: { name: "hasAccessToEditCars" },
    },
    hasAccessToEditDrivers: {
        label: "Доступ к редактированию водителей",
        type: "checkbox",
        inputProps: { name: "hasAccessToEditDrivers" },
    },
    hasAccessToEditTrailers: {
        label: "Доступ к редактированию прицепов",
        type: "checkbox",
        inputProps: { name: "hasAccessToEditTrailers" },
    },
    hasAccessToEditCounterparties: {
        label: "Доступ к редактированию контрагентов",
        type: "checkbox",
        inputProps: { name: "hasAccessToEditCounterparties" },
    },
    hasAccessToEditLegalPersons: {
        label: "Доступ к редактированию юр. лиц",
        type: "checkbox",
        inputProps: { name: "hasAccessToEditLegalPersons" },
    },
    headLogistCanEditCompletedBids: {
        label: "Главный логист может редактировать завершенные заявки",
        type: "checkbox",
        inputProps: { name: "headLogistCanEditCompletedBids" },
    },
    prohibitionOfStartingBidIfEmptyStarted: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.ProhibitionOfStartingBidIfEmptyStarted),
        type: "checkbox",
        inputProps: { name: "prohibitionOfStartingBidIfEmptyStarted" },
    },
    prohibitionOfBidDelete: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.ProhibitionOfBidDelete),
        type: "checkbox",
        inputProps: { name: "prohibitionOfBidDelete" },
    },
    skipBlockIfUnpaid: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.SkipBlockIfUnpaid),
        type: "checkbox",
        inputProps: { name: "skipBlockIfUnpaid" },
    },
    useRefuelingTransactions: {
        label: enumLabel(organizationFlags, organizationFlagsEnum.UseRefuelingTransactions),
        type: "checkbox",
        inputProps: { name: "useRefuelingTransactions" },
    },
    tileTypes: {
        label: "Тайлы для карт",
        inputProps: { name: "tileTypes" },
        options: tileTypes,
        isMulti: true,
    },
    hiddenDirection: {
        label: "Скрытые направления",
        type: "checkbox",
        inputProps: { name: "hiddenDirection" },
    },
    businessPartner: {
        config: {
            fullName: {
                label: "ФИО",
                inputProps: { name: "fullName" },
            },
            phoneNumber: {
                label: "Номер телефона",
                type: "phone",
                nullable: true,
                inputProps: { name: "phoneNumber" },
            },
            email: {
                label: "Эл. почта",
                inputProps: { name: "email", type: "email" },
            },
            daysBeforeBlockForNotification: {
                label: "Уведомлять о блокировке кабинета за, дней",
                value: defaultDaysBeforeBlockForNotification,
                inputProps: {
                    name: "daysBeforeBlockForNotification",
                    type: "number",
                    step: "1",
                    min: 1,
                },
                validators: [requiredField, positiveInteger],
            },
            shouldNotifyAboutSubscriptionExpirationEmail: {
                label: "Отправлять письмо о блокировке кабинета",
                type: "checkbox",
                fieldBeforeLabel: true,
                labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
                fieldWrapper: "col-auto offset-sm-4 offset-md-3 d-flex align-items-center",
                inputProps: { name: "shouldNotifyAboutSubscriptionExpirationEmail" },
            },
            shouldNotifyAboutSubscriptionExpirationSms: {
                label: "Отправлять SMS о блокировке кабинета",
                type: "checkbox",
                fieldBeforeLabel: true,
                labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
                fieldWrapper: "col-auto offset-sm-4 offset-md-3 d-flex align-items-center",
                inputProps: { name: "shouldNotifyAboutSubscriptionExpirationSms" },
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, defaultDaysBeforeBlockForNotification, initialState };
